import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const IconContainer = styled.div`
  vertical-align: top;
  svg {
    width: 24px;
    height: 24px;
  }
`;

const TextContainer = styled.div`
  width: 100%;
  margin-left: 1rem;
  ${({ inlineText }) => inlineText && 'display: flex; align-self: center;'}
`;

const TopTextContainer = styled.div`
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 700;
  color: ${({ textColor }) => textColor};
  ${({ inlineText }) => inlineText && 'margin-right: 0.3rem;'}
  text-transform: ${({ topTextTransform }) => topTextTransform};

  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const BottomTextContainer = styled.div`
  color: ${({ textColor }) => textColor};
`;

function PromoCallout({
  Icon,
  iconColor,
  topText,
  topTextColor,
  topTextTransform,
  bottomText,
  bottomTextColor,
  inlineText,
  urlLink,
}) {
  return (
    <Container>
      <IconContainer>
        <Icon fill={iconColor} />
      </IconContainer>

      {(topText || bottomText) && (
        <TextContainer inlineText={inlineText}>
          {topText && (
            <TopTextContainer
              textColor={topTextColor}
              inlineText={inlineText}
              topTextTransform={topTextTransform}
            >
              {urlLink && <LocalizedLink to={urlLink}>{topText}</LocalizedLink>}
              {!urlLink && topText}
            </TopTextContainer>
          )}
          {bottomText && (
            <BottomTextContainer textColor={bottomTextColor}>
              {bottomText}
            </BottomTextContainer>
          )}
        </TextContainer>
      )}
    </Container>
  );
}

PromoCallout.propTypes = {
  Icon: PropTypes.func.isRequired,
  iconColor: PropTypes.string.isRequired,
  topText: PropTypes.string,
  topTextColor: PropTypes.string,
  topTextTransform: PropTypes.string,
  bottomText: PropTypes.string,
  bottomTextColor: PropTypes.string,
  inlineText: PropTypes.bool,
  urlLink: PropTypes.string,
};

PromoCallout.defaultProps = {
  inlineText: false,
  topText: '',
  bottomText: '',
  topTextColor: 'white',
  topTextTransform: 'none',
  bottomTextColor: 'white',
  urlLink: null,
};

export default PromoCallout;
